// Mock data for Wear The Hope with Ben - Faith-based e-commerce clone

export const categories = [
  {
    id: 'drinkware',
    name: 'Drinkware',
    slug: 'drinkware',
    tagline: 'Sip scripture, hold hope',
    image: 'https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxtdWd8ZW58MHx8fHwxNzgzMzI2MTEwfDA&ixlib=rb-4.1.0&q=85',
    count: 24,
  },
  {
    id: 'clothing',
    name: 'Clothing',
    slug: 'clothing',
    tagline: 'Wear your declaration',
    image: 'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHx0c2hpcnR8ZW58MHx8fHwxNzgzMzI2MTkwfDA&ixlib=rb-4.1.0&q=85',
    count: 36,
  },
  {
    id: 'bags',
    name: 'Bags',
    slug: 'bags',
    tagline: 'Carry the message',
    image: 'https://images.unsplash.com/photo-1544816155-12df9643f363?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHx0b3RlJTIwYmFnfGVufDB8fHx8MTc4MzMyNjExMHww&ixlib=rb-4.1.0&q=85',
    count: 18,
  },
  {
    id: 'boards',
    name: 'Boards',
    slug: 'boards',
    tagline: 'Kitchen with scripture',
    image: 'https://images.unsplash.com/photo-1666013942797-9daa4b8b3b4f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxjaG9wcGluZyUyMGJvYXJkfGVufDB8fHx8MTc4MzMyNjIwMXww&ixlib=rb-4.1.0&q=85',
    count: 12,
  },
  {
    id: 'tags',
    name: 'Tags',
    slug: 'tags',
    tagline: 'Travel with purpose',
    image: 'https://images.unsplash.com/photo-1587533421909-c695540fbaac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxsdWdnYWdlJTIwdGFnfGVufDB8fHx8MTc4MzMyNjExN3ww&ixlib=rb-4.1.0&q=85',
    count: 15,
  },
  {
    id: 'badges',
    name: 'Badges & Magnets',
    slug: 'badges-magnets',
    tagline: 'Small tokens, big faith',
    image: 'https://images.unsplash.com/photo-1625768376503-68d2495d78c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxzdGlja2VyfGVufDB8fHx8MTc4MzMyNjE5MHww&ixlib=rb-4.1.0&q=85',
    count: 22,
  },
  {
    id: 'headgear',
    name: 'Head Gear',
    slug: 'head-gear',
    tagline: 'Crown of confidence',
    image: 'https://images.unsplash.com/photo-1588850561407-ed78c282e89b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxjYXB8ZW58MHx8fHwxNzgzMzI2MTE3fDA&ixlib=rb-4.1.0&q=85',
    count: 14,
  },
  {
    id: 'stickers',
    name: 'Stickers',
    slug: 'stickers',
    tagline: 'Stick the word everywhere',
    image: 'https://images.unsplash.com/photo-1633533452206-8ab246b00e30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxzdGlja2VyfGVufDB8fHx8MTc4MzMyNjE5MHww&ixlib=rb-4.1.0&q=85',
    count: 30,
  },
  {
    id: 'jewellery',
    name: 'Jewellery',
    slug: 'jewellery',
    tagline: 'Coming Soon',
    image: 'https://images.unsplash.com/photo-1499652848871-1527a310b13a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxiaWJsZXxlbnwwfHx8fDE3ODMzMjYxMTd8MA&ixlib=rb-4.1.0&q=85',
    count: 0,
    comingSoon: true,
  },
  {
    id: 'wallframes',
    name: 'Wall Frames',
    slug: 'wall-frames',
    tagline: 'Coming Soon',
    image: 'https://images.unsplash.com/photo-1699465301322-362016624dd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHx3YWxsJTIwYXJ0fGVufDB8fHx8MTc4MzMyNjExN3ww&ixlib=rb-4.1.0&q=85',
    count: 0,
    comingSoon: true,
  },
];

export const products = [
  {
    id: 'p1',
    name: 'Faith Cap — Blessed Edition',
    category: 'headgear',
    price: 899,
    originalPrice: 1199,
    image: 'https://images.unsplash.com/photo-1588850561407-ed78c282e89b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxjYXB8ZW58MHx8fHwxNzgzMzI2MTE3fDA&ixlib=rb-4.1.0&q=85',
    hoverImage: 'https://images.unsplash.com/photo-1521369909029-2afed882baee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxjYXB8ZW58MHx8fHwxNzgzMzI2MTE3fDA&ixlib=rb-4.1.0&q=85',
    verse: 'You are chosen, loved and favored',
    tag: 'Bestseller',
    rating: 4.9,
    reviews: 124,
    colors: ['#0F1F3B', '#213A60', '#4A5B6C'],
    description: 'Premium 100% cotton baseball cap with embroidered "Blessed" text. A daily reminder to walk in confidence and grace.',
  },
  {
    id: 'p2',
    name: 'Personalized Scripture Wallet',
    category: 'clothing',
    price: 1499,
    originalPrice: 1899,
    image: 'https://images.unsplash.com/photo-1627123424574-724758594e93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHx3YWxsZXR8ZW58MHx8fHwxNzgzMzI2MTkwfDA&ixlib=rb-4.1.0&q=85',
    hoverImage: 'https://images.pexels.com/photos/6444094/pexels-photo-6444094.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    verse: 'Philippians 4:19',
    tag: 'Customizable',
    rating: 5.0,
    reviews: 87,
    colors: ['#5C3A22', '#000000'],
    description: 'Handcrafted genuine leather wallet with laser-engraved name and Bible verse of your choice. Perfect personalized gift.',
  },
  {
    id: 'p3',
    name: 'YHWH Minimalist Canvas Frame',
    category: 'wallframes',
    price: 2199,
    originalPrice: 2799,
    image: 'https://images.unsplash.com/photo-1699465301322-362016624dd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHx3YWxsJTIwYXJ0fGVufDB8fHx8MTc4MzMyNjExN3ww&ixlib=rb-4.1.0&q=85',
    hoverImage: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHx3YWxsJTIwYXJ0fGVufDB8fHx8MTc4MzMyNjExN3ww&ixlib=rb-4.1.0&q=85',
    verse: 'The Most Holy Name',
    tag: 'New',
    rating: 4.8,
    reviews: 42,
    colors: ['#F5F0E8'],
    description: 'Timeless minimalist canvas featuring YHWH in stunning calligraphy. A sacred declaration for your home.',
  },
  {
    id: 'p4',
    name: 'Grace Sufficient Tote Bag',
    category: 'bags',
    price: 649,
    originalPrice: 799,
    image: 'https://images.unsplash.com/photo-1544816155-12df9643f363?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHx0b3RlJTIwYmFnfGVufDB8fHx8MTc4MzMyNjExMHww&ixlib=rb-4.1.0&q=85',
    hoverImage: 'https://images.unsplash.com/photo-1630381260512-e3fe55c11973?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHx0b3RlJTIwYmFnfGVufDB8fHx8MTc4MzMyNjExMHww&ixlib=rb-4.1.0&q=85',
    verse: '2 Corinthians 12:9',
    tag: 'Trending',
    rating: 4.7,
    reviews: 156,
    colors: ['#FFFFFF', '#F5F0E8'],
    description: 'Cotton canvas tote with hand-drawn floral wreath and "My Grace is Sufficient" print. Eco-friendly and stylish.',
  },
  {
    id: 'p5',
    name: 'Perhaps the Butterfly Tumbler',
    category: 'drinkware',
    price: 999,
    originalPrice: 1299,
    image: 'https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxtdWd8ZW58MHx8fHwxNzgzMzI2MTEwfDA&ixlib=rb-4.1.0&q=85',
    hoverImage: 'https://images.unsplash.com/photo-1516390118834-21602d501886?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxtdWd8ZW58MHx8fHwxNzgzMzI2MTEwfDA&ixlib=rb-4.1.0&q=85',
    verse: 'Perhaps the Butterfly',
    tag: 'Signature',
    rating: 4.9,
    reviews: 210,
    colors: ['#FFFFFF', '#F8C8D8'],
    description: 'Insulated skinny tumbler with a message of transformation. Keeps drinks hot for 6 hrs, cold for 12 hrs.',
  },
  {
    id: 'p6',
    name: 'Faith Coasters — Glass Set of 4',
    category: 'boards',
    price: 799,
    originalPrice: 999,
    image: 'https://images.unsplash.com/photo-1554230253-017daba2b631?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHx3b29kZW4lMjBjb2FzdGVyfGVufDB8fHx8MTc4MzMyNjExMHww&ixlib=rb-4.1.0&q=85',
    hoverImage: 'https://images.unsplash.com/photo-1587132117816-061b35073a4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHx3b29kZW4lMjBjb2FzdGVyfGVufDB8fHx8MTc4MzMyNjExMHww&ixlib=rb-4.1.0&q=85',
    verse: 'Set of 4 designs',
    tag: 'Gift Ready',
    rating: 4.8,
    reviews: 68,
    colors: ['#8B5A2B'],
    description: 'Hand-finished wooden coasters with scripture engravings. Sold in sets of 4 with unique designs.',
  },
  {
    id: 'p7',
    name: 'God Will Make A Way — Luggage Tag',
    category: 'tags',
    price: 349,
    originalPrice: 499,
    image: 'https://images.unsplash.com/photo-1587533421909-c695540fbaac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxsdWdnYWdlJTIwdGFnfGVufDB8fHx8MTc4MzMyNjExN3ww&ixlib=rb-4.1.0&q=85',
    hoverImage: 'https://images.unsplash.com/photo-1720430544263-a616840d04b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxsdWdnYWdlJTIwdGFnfGVufDB8fHx8MTc4MzMyNjExN3ww&ixlib=rb-4.1.0&q=85',
    verse: 'Isaiah 43:15-16',
    tag: 'Traveler',
    rating: 4.9,
    reviews: 92,
    colors: ['#FFDD00', '#0F1F3B'],
    description: 'Laser-engraved custom luggage tag with your name & contact. Bold, faith-fueled traveling companion.',
  },
  {
    id: 'p8',
    name: 'Wood Carved Custom Keychain',
    category: 'badges',
    price: 249,
    originalPrice: 349,
    image: 'https://images.unsplash.com/photo-1609587415882-97552f39c6c2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxrZXklMjBob2xkZXJ8ZW58MHx8fHwxNzgzMzI2MjAyfDA&ixlib=rb-4.1.0&q=85',
    hoverImage: 'https://images.unsplash.com/photo-1685886069739-c1b96bba7953?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxrZXklMjBob2xkZXJ8ZW58MHx8fHwxNzgzMzI2MjAyfDA&ixlib=rb-4.1.0&q=85',
    verse: 'Cold Burn Tech',
    tag: 'Custom',
    rating: 5.0,
    reviews: 47,
    colors: ['#8B5A2B', '#5C3A22'],
    description: 'Ultra-detailed personalized wood keychain with initials, couple names or custom designs.',
  },
  {
    id: 'p9',
    name: 'Psalm 46 Statement Tee',
    category: 'clothing',
    price: 799,
    originalPrice: 1099,
    image: 'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHx0c2hpcnR8ZW58MHx8fHwxNzgzMzI2MTkwfDA&ixlib=rb-4.1.0&q=85',
    hoverImage: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHx0c2hpcnR8ZW58MHx8fHwxNzgzMzI2MTkwfDA&ixlib=rb-4.1.0&q=85',
    verse: 'God is my refuge',
    tag: 'Bestseller',
    rating: 4.9,
    reviews: 340,
    colors: ['#0F1F3B', '#EFE7D5', '#213A60'],
    description: '100% premium cotton tee with a bold Psalm 46 print. Soft, breathable and built to last.',
  },
  {
    id: 'p10',
    name: 'Scripture Pen Stand',
    category: 'boards',
    price: 549,
    originalPrice: 749,
    image: 'https://images.unsplash.com/photo-1627629738777-b15db722c79d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxwZW4lMjBzdGFuZHxlbnwwfHx8fDE3ODMzMjYxOTB8MA&ixlib=rb-4.1.0&q=85',
    hoverImage: 'https://images.unsplash.com/photo-1620275765334-4ed948bb4502?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxub3RlYm9va3xlbnwwfHx8fDE3ODMzMjYxOTB8MA&ixlib=rb-4.1.0&q=85',
    verse: 'Any language print',
    tag: 'Multi-language',
    rating: 4.8,
    reviews: 34,
    colors: ['#8B5A2B'],
    description: 'Customized wooden pen stand with scripture in any language of your choice. Pan-India shipping.',
  },
  {
    id: 'p11',
    name: 'Christmas Borosil Glass Set (6)',
    category: 'drinkware',
    price: 1299,
    originalPrice: 1599,
    image: 'https://images.unsplash.com/photo-1643946404043-178456b0e3f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxtdWd8ZW58MHx8fHwxNzgzMzI2MTEwfDA&ixlib=rb-4.1.0&q=85',
    hoverImage: 'https://images.unsplash.com/photo-1516390118834-21602d501886?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxtdWd8ZW58MHx8fHwxNzgzMzI2MTEwfDA&ixlib=rb-4.1.0&q=85',
    verse: 'Love & Hope',
    tag: 'Festive',
    rating: 4.9,
    reviews: 78,
    colors: ['#FFFFFF'],
    description: 'Borosil juice glass set of 6 with festive Christmas engraving. Perfect for celebrations or gifting.',
  },
  {
    id: 'p12',
    name: 'Jehovah Jireh Wall Canvas',
    category: 'wallframes',
    price: 1899,
    originalPrice: 2399,
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHx3YWxsJTIwYXJ0fGVufDB8fHx8MTc4MzMyNjExN3ww&ixlib=rb-4.1.0&q=85',
    hoverImage: 'https://images.unsplash.com/photo-1699465301322-362016624dd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHx3YWxsJTIwYXJ0fGVufDB8fHx8MTc4MzMyNjExN3ww&ixlib=rb-4.1.0&q=85',
    verse: 'The Lord Will Provide',
    tag: 'New',
    rating: 4.8,
    reviews: 29,
    colors: ['#F5F0E8'],
    description: 'Minimalist canvas frame with the powerful name Jehovah Jireh. Perfect for prayer rooms or meaningful gifts.',
  },
];

export const instagramFeed = [
  { id: 'ig1', image: 'https://images.unsplash.com/photo-1627123424574-724758594e93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHx3YWxsZXR8ZW58MHx8fHwxNzgzMzI2MTkwfDA&ixlib=rb-4.1.0&q=85', caption: 'Personalized Men Wallet — DM for customization', likes: 342 },
  { id: 'ig2', image: 'https://images.unsplash.com/photo-1627629738777-b15db722c79d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxwZW4lMjBzdGFuZHxlbnwwfHx8fDE3ODMzMjYxOTB8MA&ixlib=rb-4.1.0&q=85', caption: 'Customised Scripture Pen Stand — Any Language', likes: 218 },
  { id: 'ig3', image: 'https://images.unsplash.com/photo-1643946404043-178456b0e3f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxtdWd8ZW58MHx8fHwxNzgzMzI2MTEwfDA&ixlib=rb-4.1.0&q=85', caption: 'Borosil Christmas Juice Glass Set of Six', likes: 495 },
  { id: 'ig4', image: 'https://images.unsplash.com/photo-1588850561407-ed78c282e89b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxjYXB8ZW58MHx8fHwxNzgzMzI2MTE3fDA&ixlib=rb-4.1.0&q=85', caption: 'Faith Cap Collection — Blessed, Simply Blessed, Chosen', likes: 612 },
  { id: 'ig5', image: 'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHx0c2hpcnR8ZW58MHx8fHwxNzgzMzI2MTkwfDA&ixlib=rb-4.1.0&q=85', caption: 'Psalm 46 Cotton Tees — Through every storm', likes: 428 },
  { id: 'ig6', image: 'https://images.unsplash.com/photo-1554230253-017daba2b631?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHx3b29kZW4lMjBjb2FzdGVyfGVufDB8fHx8MTc4MzMyNjExMHww&ixlib=rb-4.1.0&q=85', caption: 'Faith-Based Glass Coasters', likes: 189 },
  { id: 'ig7', image: 'https://images.unsplash.com/photo-1699465301322-362016624dd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHx3YWxsJTIwYXJ0fGVufDB8fHx8MTc4MzMyNjExN3ww&ixlib=rb-4.1.0&q=85', caption: 'YHWH — The Most Holy Name canvas', likes: 723 },
  { id: 'ig8', image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHx3YWxsJTIwYXJ0fGVufDB8fHx8MTc4MzMyNjExN3ww&ixlib=rb-4.1.0&q=85', caption: 'Jehovah Jireh — The Lord Will Provide', likes: 534 },
  { id: 'ig9', image: 'https://images.unsplash.com/photo-1609587415882-97552f39c6c2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxrZXklMjBob2xkZXJ8ZW58MHx8fHwxNzgzMzI2MjAyfDA&ixlib=rb-4.1.0&q=85', caption: 'Wood Carved Keychains — Cold Burn Tech', likes: 267 },
  { id: 'ig10', image: 'https://images.unsplash.com/photo-1587533421909-c695540fbaac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxsdWdnYWdlJTIwdGFnfGVufDB8fHx8MTc4MzMyNjExN3ww&ixlib=rb-4.1.0&q=85', caption: 'Motivational Luggage Tags with Engraved Names', likes: 401 },
];

export const testimonials = [
  { id: 't1', name: 'Anna Jacob', when: '3 months ago', rating: 5, text: 'Excellent!', avatar: 'https://ui-avatars.com/api/?name=Anna+Jacob&background=C4623B&color=fff' },
  { id: 't2', name: 'Sujata Jayaprakash', when: '6 months ago', rating: 5, text: 'I ordered 3 wallets with names and bible verses engraved for my family members. Loved the precision, customisation of names on the wallet and even the boxes making them a personalized gifts. Thank you.', avatar: 'https://ui-avatars.com/api/?name=Sujata+J&background=8B5A2B&color=fff' },
  { id: 't3', name: 'Mathew Dalis', when: '6 months ago', rating: 5, text: 'Very nice quality. Great looks. Wonderful service.', avatar: 'https://ui-avatars.com/api/?name=Mathew+Dalis&background=0F1F3B&color=fff' },
  { id: 't4', name: 'TravelWell', when: '6 months ago', rating: 5, text: 'Very exquisite set of Glasses. Loved it. Thanks', avatar: 'https://ui-avatars.com/api/?name=Travel+Well&background=B4593F&color=fff' },
  { id: 't5', name: 'Adarsh S', when: '8 months ago', rating: 5, text: 'Love how Wear the Hope reminds us that even our fashion can glorify God! Good vibes, better message, best quality.', avatar: 'https://ui-avatars.com/api/?name=Adarsh+S&background=5C3A22&color=fff' },
  { id: 't6', name: 'John K', when: '8 months ago', rating: 5, text: 'We recently ordered these super cool flasks with our company logo & slogan printed for Diwali. The build quality was amazing. Value: 5/5. Quality: 5/5. Delivery: 5/5.', avatar: 'https://ui-avatars.com/api/?name=John+K&background=1A1A1A&color=fff' },
];

export const heroSlides = [
  {
    id: 'h1',
    heading: 'Share the Message of',
    accent: 'Love & Hope',
    subheading: 'Faith-driven products, crafted to impact lives',
    cta: 'Shop the Collection',
    href: '/shop',
    image: 'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHx0c2hpcnR8ZW58MHx8fHwxNzgzMzI2MTkwfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'h2',
    heading: 'Personalize with',
    accent: 'Scripture',
    subheading: 'Laser-engraved wallets, boards & tags — made to order',
    cta: 'Explore Customization',
    href: '/shop/tags',
    image: 'https://images.unsplash.com/photo-1627123424574-724758594e93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHx3YWxsZXR8ZW58MHx8fHwxNzgzMzI2MTkwfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'h3',
    heading: 'New Drop — Faith',
    accent: 'Cap Collection',
    subheading: 'Blessed. Simply Blessed. Chosen. Wear who you are in Christ.',
    cta: 'Discover Caps',
    href: '/shop/head-gear',
    image: 'https://images.unsplash.com/photo-1588850561407-ed78c282e89b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxjYXB8ZW58MHx8fHwxNzgzMzI2MTE3fDA&ixlib=rb-4.1.0&q=85',
  },
];

export const brandInfo = {
  name: 'Wear The Hope with Ben',
  tagline: 'Share The Message of Love and Hope',
  established: 'December 2018',
  usPartner: 'https://www.wearthehope.us/',
  instagram: 'https://www.instagram.com/wearthehope',
  phone: '+91 9004373305',
  email: 'hello@wearthehope.com',
};
